/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SelectIntersectIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Select Intersect',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2 10h2v6H2zM4 22v-2H2v3.111a.889.889 0 0 0 .889.889H8v-2ZM14 32v-4h-2v5.111a.889.889 0 0 0 .889.889H16v-2ZM20 32h6v2h-6zM32 20h2v6h-2zM32 30v2h-2v2h3a1 1 0 0 0 1-1v-3ZM23.111 2H20v2h2v4h2V2.889A.889.889 0 0 0 23.111 2ZM33.111 12H28v2h4v2h2v-3.111a.889.889 0 0 0-.889-.889ZM10 2h6v2h-6zM6 2H3a1 1 0 0 0-1 1v3h2V4h2ZM12 12h2.25v2.263H12zM16.84 12h2.25v2.263h-2.25zM21.739 12.01h2.25v2.263h-2.25zM12 16.824h2.25v2.263H12zM16.84 16.824h2.25v2.263h-2.25zM16.84 21.507h2.25v2.263h-2.25zM21.739 16.834h2.25v2.263h-2.25zM12.01 21.737h2.25V24h-2.25zM21.749 21.507h2.25v2.263h-2.25z"
    />
  </svg>`;
};
